import React, { useEffect, useState } from "react";
import { Users2, CalendarX2, UserCheck, Lock } from "lucide-react";
import api from "../../lib/api";
import { toast } from "sonner";
import { ukDate } from "../../lib/dates";

const CARD = "bg-white rounded-2xl border border-[#EBE9E4] shadow-[0_8px_30px_rgba(45,45,45,0.04)]";

export const TeamsOverview = () => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/teams/overview").then(({ data }) => setData(data)).catch(() => toast.error("Couldn't load the teams overview")); }, []);
  if (!data) return null;
  const stats = [["Teams", data.totals.teams, Users2], ["People serving", data.totals.members, UserCheck], ["Open rota slots", data.totals.open_slots, CalendarX2], ["Pending applications", data.totals.pending, UserCheck]];
  return (
    <div className={`${CARD} p-6`} data-testid="teams-overview">
      <h2 className="font-head text-lg font-bold">Teams overview</h2>
      <div className="mt-3 grid grid-cols-2 md:grid-cols-4 gap-3">
        {stats.map(([l, n, Icon]) => (
          <div key={l} className="rounded-xl border p-3" style={{ borderColor: "var(--sj-border)", background: "#FBFAF7" }} data-testid={`teams-overview-stat-${l.toLowerCase().replace(/\s+/g, "-")}`}>
            <Icon className="h-4 w-4" style={{ color: "var(--sj-primary)" }} />
            <div className="text-2xl font-extrabold font-head mt-1" style={{ color: "var(--sj-primary)" }}>{n}</div>
            <div className="text-xs" style={{ color: "var(--sj-text-3)" }}>{l}</div>
          </div>
        ))}
      </div>
      <div className="mt-4 overflow-x-auto max-h-80 overflow-y-auto">
        <table className="w-full text-sm">
          <thead className="sticky top-0 bg-white"><tr className="text-left text-xs uppercase tracking-wider" style={{ color: "var(--sj-text-3)" }}><th className="py-2 pr-3">Team</th><th className="py-2 px-3 text-right">Members</th><th className="py-2 px-3 text-right">Open slots</th><th className="py-2 px-3">Next gap</th><th className="py-2 pl-3 text-right">Pending</th></tr></thead>
          <tbody>
            {data.rows.map((r) => (
              <tr key={r.id} className="border-t border-[#EBE9E4]" data-testid={`teams-overview-row-${r.id}`}>
                <td className="py-2 pr-3 font-medium"><span className="inline-flex items-center gap-1.5">{r.name}{r.confidential && <Lock className="h-3 w-3" style={{ color: "var(--sj-text-3)" }} />}</span>{r.category && <span className="block text-xs" style={{ color: "var(--sj-text-3)" }}>{r.category}</span>}</td>
                <td className="py-2 px-3 text-right">{r.size}</td>
                <td className="py-2 px-3 text-right font-semibold" style={{ color: r.open_slots ? "#B45309" : "var(--sj-text-3)" }}>{r.open_slots}</td>
                <td className="py-2 px-3 text-xs" style={{ color: "var(--sj-text-2)" }}>{r.next_open_week ? `Sun ${ukDate(r.next_open_week)}` : "—"}</td>
                <td className="py-2 pl-3 text-right">{r.pending ? <span className="rounded-full px-2 py-0.5 text-xs font-bold text-white" style={{ background: "var(--sj-primary)" }}>{r.pending}</span> : <span style={{ color: "var(--sj-text-3)" }}>0</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
